import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function AboutSection() {
  return <section className="py-20 md:py-32 bg-cream-dark relative overflow-hidden" data-id="element-17">
      <div className="absolute top-10 right-0 w-96 h-96 bg-sage-100 rounded-full mix-blend-multiply filter blur-3xl opacity-40 pointer-events-none" data-id="element-18"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-19">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-20">
          {/* Photo */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7
        }} className="lg:col-span-5 relative" data-id="element-21">
            <div className="relative rounded-[2rem] overflow-hidden shadow-2xl aspect-[4/5] max-w-md mx-auto" data-id="element-22">
              <img src="https://cdn.magicpatterns.com/uploads/iTvjMtv67WF1FZPzgN2shS/Opcion_1_para_Anuncio_1.png" alt="Carolina M., creadora del programa Vuelve a Sentirte Tú" className="w-full h-full object-cover object-top" data-id="element-23" />
              {/* Floating badge */}
              <div className="absolute -bottom-4 -right-4 bg-cream rounded-2xl shadow-xl p-4 border border-sage-100" data-id="element-24">
                <p className="text-xs uppercase tracking-widest text-sage-700 font-semibold" data-id="element-25">
                  Creadora del programa
                </p>
                <p className="font-serif text-2xl font-bold text-sage-800" data-id="element-26">
                  Carolina M.
                </p>
              </div>
            </div>
            {/* Decorative element */}
            <div className="absolute -inset-4 bg-sage-100/40 rounded-[3rem] -z-10 transform -rotate-2 hidden md:block" data-id="element-27"></div>
          </motion.div>

          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7,
          delay: 0.1
        }} className="lg:col-span-7" data-id="element-28">
            <span className="inline-block py-1 px-3 rounded-full bg-sage-100 text-sage-800 text-xs font-semibold tracking-widest uppercase mb-6" data-id="element-29">
              Quién Soy
            </span>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight" data-id="element-30">
              Hola, soy <span className="text-sage-700 italic" data-id="element-31">Carolina</span>.
            </h2>

            <p className="text-lg text-charcoal-light leading-relaxed mb-5" data-id="element-32">
              A los 44 años, mi cuerpo dejó de responderme. Subí 8 kilos en 6
              meses sin cambiar nada, no podía dormir, los sofocos me
              despertaban a las 3am, y la neblina mental me hacía sentir que
              estaba perdiendo el control.
            </p>

            <p className="text-lg text-charcoal-light leading-relaxed mb-5" data-id="element-33">
              Visité a 4 médicos. Todos me dijeron lo mismo:{' '}
              <em data-id="element-34">"es normal a tu edad, acostúmbrate"</em>. Pero algo dentro de
              mí sabía que{' '}
              <strong className="text-sage-700 font-semibold" data-id="element-35">
                no era normal sentirse así
              </strong>
              .
            </p>

            <p className="text-lg text-charcoal-light leading-relaxed mb-8" data-id="element-36">
              Pasé 3 años estudiando endocrinología funcional, nutrición
              metabólica y manejo del cortisol. Apliqué todo en mí misma.{' '}
              <strong className="text-sage-700 font-semibold" data-id="element-37">
                Hoy peso lo mismo que a los 35, duermo de corrido, y tengo más
                energía que nunca.
              </strong>{' '}
              Este programa es el camino que me devolvió mi vida — y ahora
              quiero compartirlo contigo.
            </p>

            {/* Quote callout */}
            <div className="bg-cream border-l-4 border-sage-700 pl-6 py-4 rounded-r-xl" data-id="element-38">
              <Quote size={24} className="text-sage-600 mb-2" data-id="element-39" />
              <p className="font-serif text-xl italic text-charcoal leading-relaxed" data-id="element-40">
                "No tienes que resignarte. Tu cuerpo solo necesita el manual
                correcto."
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}